module.exports = __webpack_public_path__ + "images/85195afc226d184dee7460ab5b5feb76.svg";